import { Component, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'app-wrapper-content-cabinet',
    templateUrl: './wrapper-content.component.html',
    styleUrl: './wrapper-content.component.scss',
    encapsulation: ViewEncapsulation.ShadowDom
})
export class WrapperContentCabinetComponent {

}
